import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useParams } from 'react-router-dom';
import Layout from "./Components/Layout";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Button, Modal, Tab, Tabs} from "react-bootstrap";
import VendorsTab from "./Components/VendorsTab";

const ViewRawsRecord = () => {
    const [fileList, setFileList] = useState([]);
    const [rawsData, setRawsData] = useState(0);
    const [id, setId] = useState('');
    const [rawMaterialName, setRawMaterialName] = useState('');
    const [activeInactive, setActiveInactive] = useState('');
    const [identityTestingCost, setIdentityTestingCost] = useState('');
    const [testingMethod, setTestingMethod] = useState('');
    const [typeMicroLimit, setTypeMicroLimit] = useState('');
    const [commonName, setCommonName] = useState('');
    const [botanicalName, setBotanicalName] = useState('');
    const [hoc, setHOC] = useState('');
    const [part, setPart] = useState('');
    const [form, setForm] = useState('');
    const [ratio, setRatio] = useState('');
    const [lodNmt, setLOD_NMT] = useState('');
    const [loiNmt, setLOI_NMT] = useState('');
    const [ingredientDeclarationOnLabel, setIngredientDeclarationOnLabel] = useState('');
    const [identity, setIdentity] = useState('');
    const [limit0, setLimit0] = useState('');
    const [limit0Method, setLimit0Method] = useState('');
    const [limit0Reference, setLimit0Reference] = useState('');
    const [limit0TestingCost, setLimit0TestingCost] = useState('');
    const [active1, setActive1] = useState('');
    const [limit1, setLimit1] = useState('');
    const [limit1Method, setLimit1Method] = useState('');
    const [limit1Reference, setLimit1Reference] = useState('');
    const [limit1TestingCost, setLimit1TestingCost] = useState('');
    const [active2, setActive2] = useState('');
    const [limit2, setLimit2] = useState('');
    const [limit2Method, setLimit2Method] = useState('');
    const [limit2Reference, setLimit2Reference] = useState('');
    const [limit2TestingCost, setLimit2TestingCost] = useState('');
    const [appearance, setAppearance] = useState('');
    const [color, setColor] = useState('');
    const [odor, setOdor] = useState('');
    const [taste, setTaste] = useState('');
    const [bulk, setBulk] = useState('');
    const [tapped, setTapped] = useState('');
    const [meshSize, setMeshSize] = useState('');
    const [arsenic, setArsenic] = useState('');
    const [cadmium, setCadmium] = useState('');
    const [leadx, setLeadx] = useState('');
    const [mercury, setMercury] = useState('');
    const [tamc, setTAMC] = useState('');
    const [tymc, setTYMC] = useState('');
    const [coliforms, setColiforms] = useState('');
    const [eColi, setEColi] = useState('');
    const [salmonellaSpp, setSalmonellaSpp] = useState('');
    const [staphAureus, setStaphAureus] = useState('');
    const [absent, setAbsent] = useState('');
    const [milk, setMilk] = useState('');
    const [egg, setEgg] = useState('');
    const [soy, setSoy] = useState('');
    const [fish, setFish] = useState('');
    const [shellfish, setShellfish] = useState('');
    const [treeNuts, setTreeNuts] = useState('');
    const [peanuts, setPeanuts] = useState('');
    const [wheat, setWheat] = useState('');
    const [gluten, setGluten] = useState('');
    const [overage, setOverage] = useState('');
    const [cost, setCost] = useState('');
    const [costUnit, setCostUnit] = useState('');
    const [costG, setCostG] = useState('');
    const [moqKg, setMOQKg] = useState('');
    const [amazonTesting, setAmazonTesting] = useState('');
    const [laboratory, setLaboratory] = useState('');
    const [solubilityGML, setSolubilityGML] = useState('');
    const [specRevision, setSpecRevision] = useState('');
    const [specEffectiveDate, setSpecEffectiveDate] = useState('');
    const [storageRequirements, setStorageRequirements] = useState('');
    const [shelfLife, setShelfLife] = useState('');
    const [countryOfOrigin, setCountryOfOrigin] = useState('');
    const [show, setShow] = useState(false);
    const [file, setFile] = useState(null);
    const [isNewRecord, setIsNewRecord] = useState(false);

    let { dataId } = useParams();
    useEffect(() => {
        axios.get(`raws/get-raws-data/${dataId}`)
            .then(response => {
                const raws = response.data.data;
                setRawsData(raws);
                setId(raws['Id']);
                setRawMaterialName(raws['RawMaterialName']);
                setActiveInactive(raws['ActiveInactive']);
                setIdentityTestingCost(raws['IdentityTestingCost']);
                setTestingMethod(raws['TestingMethod']);
                setTypeMicroLimit(raws['Type_MicroLimit']);
                setCommonName(raws['CommonName']);
                setBotanicalName(raws['BotanicalName']);
                setHOC(raws['HOC']);
                setPart(raws['Part']);
                setForm(raws['Form']);
                setRatio(raws['Ratio']);
                setLOD_NMT(raws['LOD_NMT']);
                setLOI_NMT(raws['LOI_NMT']);
                setIngredientDeclarationOnLabel(raws['IngredientDeclarationonLabel']);
                setIdentity(raws['Identity']);
                setLimit0(raws['Limit0']);
                setLimit0Method(raws['Limit0Method']);
                setLimit0Reference(raws['Limit0Reference']);
                setLimit0TestingCost(raws['Limit0TestingCost']);
                setActive1(raws['Active1']);
                setLimit1(raws['Limit1']);
                setLimit1Method(raws['Limit1Method']);
                setLimit1Reference(raws['Limit1Reference']);
                setLimit1TestingCost(raws['Limit1TestingCost']);
                setActive2(raws['Active2']);
                setLimit2(raws['Limit2']);
                setLimit2Method(raws['Limit2Method']);
                setLimit2Reference(raws['Limit2Reference']);
                setLimit2TestingCost(raws['Limit2TestingCost']);
                setAppearance(raws['Appearance']);
                setColor(raws['Color']);
                setOdor(raws['Odor']);
                setTaste(raws['Taste']);
                setBulk(raws['Bulk']);
                setTapped(raws['Tapped']);
                setMeshSize(raws['MeshSize']);
                setArsenic(raws['Arsenic']);
                setCadmium(raws['Cadmium']);
                setLeadx(raws['Leadx']);
                setMercury(raws['Mercury']);
                setTAMC(raws['TAMC']);
                setTYMC(raws['TYMC']);
                setColiforms(raws['Coliforms']);
                setEColi(raws['E_coli']);
                setSalmonellaSpp(raws['Salmonellaspp']);
                setStaphAureus(raws['Staphaureus']);
                setAbsent(raws['Absent']);
                setMilk(raws['Milk']);
                setEgg(raws['Egg']);
                setSoy(raws['Soy']);
                setFish(raws['Fish']);
                setShellfish(raws['Shellfish']);
                setTreeNuts(raws['TreeNuts']);
                setPeanuts(raws['Peanuts']);
                setWheat(raws['Wheat']);
                setGluten(raws['Gluten']);
                setOverage(raws['Overage']);
                setCost(raws['Cost']);
                setCostUnit(raws['CostUnit']);
                setCostG(raws['Cost_g']);
                setMOQKg(raws['MOQ_kg']);
                setAmazonTesting(raws['AmazonTesting']);
                setLaboratory(raws['Laboratory']);
                setSolubilityGML(raws['Solubility_g_mL']);
                setSpecRevision(raws['SpecRevision'] || '');
                setSpecEffectiveDate(raws['SpecEffectiveDate'] || '');
                setStorageRequirements(raws['StorageRequirements'] || '');
                setShelfLife(raws['ShelfLife'] || '');
                setCountryOfOrigin(raws['CountryOfOrigin'] || '');
                setIsNewRecord(raws['is_new_record'] === 1);
            });

        axios.get(`raws/get-raws-file/${dataId}`)
            .then(response => {
                const raws = response.data.data;
                setFileList(raws);
            });

    }, [dataId]);

    const onSaveClick = () => {
        let dataObj = {
            id,
            rawsId : dataId,
            rawMaterialName,
            activeInactive,
            identityTestingCost,
            testingMethod,
            typeMicroLimit,
            commonName,
            botanicalName,
            hoc,
            part,
            form,
            ratio,
            lodNmt,
            loiNmt,
            ingredientDeclarationOnLabel,
            identity,
            limit0,
            limit0Method,
            limit0Reference,
            limit0TestingCost,
            active1,
            limit1,
            limit1Method,
            limit1Reference,
            limit1TestingCost,
            active2,
            limit2,
            limit2Method,
            limit2Reference,
            limit2TestingCost,
            appearance,
            color,
            odor,
            taste,
            bulk,
            tapped,
            meshSize,
            arsenic,
            cadmium,
            leadx,
            mercury,
            tamc,
            tymc,
            coliforms,
            eColi,
            salmonellaSpp,
            staphAureus,
            absent,
            milk,
            egg,
            soy,
            fish,
            shellfish,
            treeNuts,
            peanuts,
            wheat,
            gluten,
            overage,
            cost,
            costUnit,
            costG,
            moqKg,
            amazonTesting,
            laboratory,
            solubilityGML,
            specRevision,
            specEffectiveDate: specEffectiveDate || null,
            storageRequirements,
            shelfLife,
            countryOfOrigin
        };
        axios.put(`raws/update-raws-data`, dataObj)
            .then(() => {
                toast.success('Data updated Successfully!');
                // Redirect to raws list after a short delay to show the toast
                setTimeout(() => {
                    window.location.href = "/parts";
                }, 1500);
            });
    };

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleDownload = (fileId) => {
        var baseUrl = axios.defaults.baseURL;
        baseUrl += `raws/download/${fileId}`
        window.open(baseUrl);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('file', file);
        formData.append('rawsId', dataId);
        try {
            const response = await axios.post('raws/add-raws-file', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log('Response:', response.data);
            toast.success('File added Successfully!')
            handleClose()
            window.location.reload()
        } catch (error) {
            console.error('Error submitting data:', error);
            toast.error('Error submitting file!')
            handleClose()
        }
    }

    const handleMarkReviewed = async () => {
        try {
            await axios.put(`/api/new-records/raws/${rawsData.RawsId || dataId}/review`);
            setIsNewRecord(false);
            toast.success('Record marked as reviewed');
        } catch (error) {
            toast.error('Failed to mark as reviewed');
        }
    };

    return (
        <Layout>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>File Upload</Modal.Title>
                    <button type="button" className="btn-close" aria-label="Close" onClick={handleClose} style={{border: "none", background: "#fff"}}>
                        <i className="ti-close"></i>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <label>Upload File</label>
                    <input type="file" onChange={handleFileChange}/>
                    <Button variant="secondary" onClick={handleSubmit}>
                        Save
                    </Button>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            
            <div style={{ height: 'calc(100vh - 70px)', overflow: 'auto', padding: '20px' }}>
                <div className="container-fluid" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                    
                    {/* New Record Review Banner */}
                    {isNewRecord && (
                        <div style={{
                            backgroundColor: '#eff6ff',
                            border: '1px solid #bfdbfe',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            marginBottom: '16px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <span style={{ color: '#1e40af', fontWeight: '500' }}>
                                <i className="ti-info-alt" style={{ marginRight: '8px' }}></i>
                                This is a new record pending review.
                            </span>
                            <Button variant="primary" size="sm" onClick={handleMarkReviewed}>
                                Mark as Reviewed
                            </Button>
                        </div>
                    )}

                    {/* Breadcrumb */}
                    <div style={{ marginBottom: '20px' }}>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb" style={{ background: 'transparent', padding: '0', margin: '0' }}>
                                <li className="breadcrumb-item">
                                    <a href="/parts" style={{ color: '#6b7280', textDecoration: 'none' }}>
                                        <i className="ti-arrow-left" style={{ marginRight: '5px' }}></i>
                                        Parts
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page" style={{ color: '#333', fontWeight: '500' }}>
                                    View Part Details
                                </li>
                            </ol>
                        </nav>
                    </div>

                    <Tabs defaultActiveKey="data" id="uncontrolled-tab-example" className="nav-pills" style={{ marginBottom: '20px' }}>
                        <Tab eventKey="data" title="Part Details">
                            <form onSubmit={(e) => {e.preventDefault(); onSaveClick();}}>
                                <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '24px' }}>
                                    <h4 style={{ fontWeight: '600', marginBottom: '20px', color: '#333' }}>Part Information</h4>
                                    
                                    <div className="row">
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>APEXID#</label>
                                            <input 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                value={id} 
                                                onChange={(e) => setId(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Raw Material Name</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={rawMaterialName} 
                                                onChange={(e) => setRawMaterialName(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Active/Inactive</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={activeInactive} 
                                                onChange={(e) => setActiveInactive(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Identity Testing Cost</label>
                                            <input 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                value={identityTestingCost} 
                                                onChange={(e) => setIdentityTestingCost(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Testing Method</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={testingMethod} 
                                                onChange={(e) => setTestingMethod(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Type (Micro Limit)</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={typeMicroLimit} 
                                                onChange={(e) => setTypeMicroLimit(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Common Name</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={commonName} 
                                                onChange={(e) => setCommonName(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Botanical Name</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={botanicalName} 
                                                onChange={(e) => setBotanicalName(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>HOC</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={hoc} 
                                                onChange={(e) => setHOC(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Part</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={part} 
                                                onChange={(e) => setPart(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Form</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={form} 
                                                onChange={(e) => setForm(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Ratio</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={ratio} 
                                                onChange={(e) => setRatio(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>LOD(NMT)</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={lodNmt} 
                                                onChange={(e) => setLOD_NMT(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>LOI(NMT)</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={loiNmt} 
                                                onChange={(e) => setLOI_NMT(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-12 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Ingredient Declaration On Label</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={ingredientDeclarationOnLabel} 
                                                onChange={(e) => setIngredientDeclarationOnLabel(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Identity</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={identity} 
                                                onChange={(e) => setIdentity(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Limit</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={limit0} 
                                                onChange={(e) => setLimit0(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Method</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={limit0Method} 
                                                onChange={(e) => setLimit0Method(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Reference</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={limit0Reference} 
                                                onChange={(e) => setLimit0Reference(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Testing Cost</label>
                                            <input 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                value={limit0TestingCost} 
                                                onChange={(e) => setLimit0TestingCost(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Active1</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={active1} 
                                                onChange={(e) => setActive1(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Limit1</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={limit1} 
                                                onChange={(e) => setLimit1(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Method</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={limit1Method} 
                                                onChange={(e) => setLimit1Method(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Reference</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={limit1Reference} 
                                                onChange={(e) => setLimit1Reference(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Testing Cost</label>
                                            <input 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                value={limit1TestingCost} 
                                                onChange={(e) => setLimit1TestingCost(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Active2</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={active2} 
                                                onChange={(e) => setActive2(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Limit2</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={limit2} 
                                                onChange={(e) => setLimit2(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Method</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={limit2Method} 
                                                onChange={(e) => setLimit2Method(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Reference</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={limit2Reference} 
                                                onChange={(e) => setLimit2Reference(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Testing Cost</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={limit2TestingCost} 
                                                onChange={(e) => setLimit2TestingCost(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Appearance</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={appearance} 
                                                onChange={(e) => setAppearance(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Color</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={color} 
                                                onChange={(e) => setColor(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Odor</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={odor} 
                                                onChange={(e) => setOdor(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Taste</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={taste} 
                                                onChange={(e) => setTaste(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Bulk</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={bulk} 
                                                onChange={(e) => setBulk(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Tapped</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={tapped} 
                                                onChange={(e) => setTapped(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Mesh Size</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={meshSize} 
                                                onChange={(e) => setMeshSize(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Arsenic</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={arsenic} 
                                                onChange={(e) => setArsenic(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Cadmium</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={cadmium} 
                                                onChange={(e) => setCadmium(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Lead</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={leadx} 
                                                onChange={(e) => setLeadx(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Mercury</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={mercury} 
                                                onChange={(e) => setMercury(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>TAMC</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={tamc} 
                                                onChange={(e) => setTAMC(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>TYMC</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={tymc} 
                                                onChange={(e) => setTYMC(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Coliforms</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={coliforms} 
                                                onChange={(e) => setColiforms(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>E. coli</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={eColi} 
                                                onChange={(e) => setEColi(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Salmonella spp.</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={salmonellaSpp} 
                                                onChange={(e) => setSalmonellaSpp(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Staph aureus</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={staphAureus} 
                                                onChange={(e) => setStaphAureus(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Absent</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={absent} 
                                                onChange={(e) => setAbsent(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Milk</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={milk} 
                                                onChange={(e) => setMilk(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Egg</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={egg} 
                                                onChange={(e) => setEgg(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Soy</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={soy} 
                                                onChange={(e) => setSoy(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Fish</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={fish} 
                                                onChange={(e) => setFish(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Shellfish</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={shellfish} 
                                                onChange={(e) => setShellfish(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Tree Nuts</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={treeNuts} 
                                                onChange={(e) => setTreeNuts(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Peanuts</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={peanuts} 
                                                onChange={(e) => setPeanuts(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Wheat</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={wheat} 
                                                onChange={(e) => setWheat(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Gluten*</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={gluten} 
                                                onChange={(e) => setGluten(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Overage</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={overage} 
                                                onChange={(e) => setOverage(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Cost</label>
                                            <input 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                value={cost} 
                                                onChange={(e) => setCost(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Cost Unit</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={costUnit} 
                                                onChange={(e) => setCostUnit(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Cost/g</label>
                                            <input 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                value={costG} 
                                                onChange={(e) => setCostG(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>MOQ (kg)</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={moqKg} 
                                                onChange={(e) => setMOQKg(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Amazon Testing</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={amazonTesting} 
                                                onChange={(e) => setAmazonTesting(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Laboratory</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={laboratory} 
                                                onChange={(e) => setLaboratory(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Solubility (g/mL)</label>
                                            <input 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                value={solubilityGML} 
                                                onChange={(e) => setSolubilityGML(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                    </div>

                                    {/* Spec Information */}
                                    <h4 style={{ fontWeight: '600', marginTop: '32px', marginBottom: '20px', color: '#333' }}>Spec Information</h4>
                                    <div className="row">
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Spec Revision</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={specRevision}
                                                onChange={(e) => setSpecRevision(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Spec Effective Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={specEffectiveDate}
                                                onChange={(e) => setSpecEffectiveDate(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Storage Requirements</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={storageRequirements}
                                                onChange={(e) => setStorageRequirements(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Shelf Life</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={shelfLife}
                                                onChange={(e) => setShelfLife(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Country of Origin</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={countryOfOrigin}
                                                onChange={(e) => setCountryOfOrigin(e.target.value)}
                                                style={{ height: '45px' }}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #e5e7eb', display: 'flex', gap: '12px' }}>
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            style={{ padding: '12px 24px', fontWeight: '500' }}
                                        >
                                            Save Changes
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            style={{ padding: '12px 24px', fontWeight: '500' }}
                                            onClick={async () => {
                                                try {
                                                    const response = await axios.get(`spec-pdf/export/${dataId}`, { responseType: 'blob' });
                                                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                                                    const link = document.createElement('a');
                                                    link.href = url;
                                                    link.setAttribute('download', `Spec_${dataId}.pdf`);
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    link.remove();
                                                    window.URL.revokeObjectURL(url);
                                                } catch (error) {
                                                    toast.error('Failed to export specification PDF');
                                                    console.error('Error exporting spec PDF:', error);
                                                }
                                            }}
                                        >
                                            <i className="ti-download" style={{ marginRight: '8px' }}></i>
                                            Export Specification (PDF)
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </Tab>
                        <Tab eventKey="files" title="Files">
                            <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '24px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                    <h4 style={{ fontWeight: '600', margin: 0, color: '#333' }}>Attached Files</h4>
                                    <button 
                                        className='btn btn-primary'
                                        onClick={(e) => handleShow(e)}
                                        style={{ padding: '8px 16px', fontWeight: '500' }}
                                    >
                                        <i className={'ti-upload'} style={{ marginRight: '8px' }}></i> 
                                        Upload Files
                                    </button>
                                </div>
                                
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead style={{ backgroundColor: '#f8f9fa' }}>
                                            <tr>
                                                <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>File name</th>
                                                <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none', width: '100px' }}>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileList.map((p, index) => (
                                                <tr key={index} style={{ cursor: 'pointer' }}>
                                                    <td style={{ padding: '12px 16px', border: 'none' }}>{p.actualname}</td>
                                                    <td style={{ padding: '12px 16px', border: 'none', textAlign: 'center' }}>
                                                        <button 
                                                            className="btn btn-sm btn-outline-primary"
                                                            onClick={(e) => handleDownload(p.filename)}
                                                        >
                                                            <i className="ti-download"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            
                                            {fileList.length === 0 && (
                                                <tr>
                                                    <td colSpan="2" style={{ padding: '32px', textAlign: 'center', color: '#6b7280' }}>
                                                        <i className="ti-files" style={{ fontSize: '48px', color: '#6c757d' }}></i>
                                                        <p className="mt-3 mb-0">No files uploaded</p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Tab>
                        <Tab eventKey="vendors" title="Vendors">
                            <VendorsTab rawsId={dataId} />
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </Layout>
    );
}

export default ViewRawsRecord;